import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
// import { Container } from 'reactstrap';

// Local Deps
import './ToolingLocations.scss';
import msgs from '../../config/messages';
import { isLoggedIn } from '../../components/Auth/utils';


// Components
import ToolingLocationsSearch from '../../components/ToolingLocations/ToolingLocationsSearch';
import ToolingLocationsForm from '../../components/ToolingLocations/ToolingLocationsForm';
import Subscription, { isAllowed } from '../../components/Subscription/Subscription';
import { SubsContext } from '../../components/Billsby/SubscriptionInfo';

export default function ToolingLocations({ auth }) {
  const { subscriptionLevel } = useContext(SubsContext);
  const hasJwt = isLoggedIn(auth);
  const isAuthorized = true;
  const hasSubscriptionAccess = isAllowed('ICON Core', subscriptionLevel);
  const showToolingSearch = hasJwt && isAuthorized && hasSubscriptionAccess;
  const isCoreOnly = subscriptionLevel === 'ICON Core';

  return (
    <Subscription service="Item Search" level="ICON Core">
      <div className="nf-tooling-locations">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Items Search Page</title>
          <meta
            name="description"
            content="Complete a form or register for the ICON Portal to source casting suppliers and defense-related patterns.  NFFS Staff will perform searches free of charge for non-registered users."
          />
          <meta
            name="keywords"
            content="machine tooling,casting tooling, military castings,amc icon,foundry tooling,defense tooling,defense-related patterns"
          />
        </Helmet>

        {/* <!-- HEADER --> */}

        <h1 className="nf-tooling-locations__header">
          {showToolingSearch ? msgs.ToolingSearch.header : msgs.Tooling.header}
        </h1>
        {auth.role === 'GOVERNMENT_USER' ? (
          <div className="nf-tooling-locations-message">
            If you are accessing the ICON Portal from the DLA network then you
            may need to refresh your browser in order to see search results.
            This is due to load time restrictions enforced on the DLA network.
          </div>
        ) : (
          ''
        )}
        {/* <!-- TOOLING FORM --> */}
        {showToolingSearch ? (
          <ToolingLocationsSearch
            auth={auth}
            isCoreOnly={isCoreOnly}
          // setUniversalDetailsHistory={setUniversalDetailsHistory}
          />
        ) : (
          <ToolingLocationsForm />
        )}

      </div>
    </Subscription>
  );
}

ToolingLocations.propTypes = {
  // location: PropTypes.object.isRequired,

  auth: PropTypes.shape({
    jwtToken: PropTypes.string,
    expiration: PropTypes.number,
    role: PropTypes.string,
  }).isRequired,
  // setUniversalDetailsHistory: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/ToolingLocations/ToolingLocations.jsx